import {z} from 'zod'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {InputDate} from '@/components/commons/input-date/InputDate'
import dayjs from 'dayjs'
import {InputText} from '@/components/commons/input-text/InputText'

const MedicalReportExtendedProjectFieldsSchema = MedicalReportFieldsSchema.pick({
    newProjectStartDate: true,
    newProjectDurationDays: true,
    project: true
})
type MedicalReportExtendedProjectFieldsSchema = z.infer<typeof MedicalReportExtendedProjectFieldsSchema>

export const MedicalReportExtendedProjectFields = () => {
    const {t} = useTranslation()
    const form = useFormContext<MedicalReportExtendedProjectFieldsSchema>()
    const project = useWatch({control: form.control, name: 'project'})

    return (
        <Grid columns={3} gap={4}>
            <GridItem spanColumn={1} direction="column">
                <Controller
                    name="newProjectStartDate"
                    control={form.control}
                    render={({field, fieldState}) => (
                        <InputDate
                            label={t('medical_records:project_to_extend_date')}
                            placeholder="GG/MM/AAAA"
                            errorMessage={fieldState.error?.message}
                            defaultMonth={
                                project?.expirationDate
                                    ? dayjs(project.expirationDate).add(1, 'day').toDate()
                                    : undefined
                            }
                            disableBeforeDate={
                                project?.expirationDate
                                    ? dayjs(project.expirationDate).add(1, 'day').toDate()
                                    : undefined
                            }
                            fullWidth
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />
            </GridItem>
            <GridItem spanColumn={1} direction="column">
                <InputText
                    type="number"
                    label={t('medical_records:new_project_duration')}
                    placeholder={t('projects:add_duration')}
                    {...form.register('newProjectDurationDays', {valueAsNumber: true})}
                />
            </GridItem>
        </Grid>
    )
}
